import ConnectorType, { getConnectorTypeSvg } from 'components/ConnectorType';
import { getVehicleIcon } from 'util/getComponentIcon';
import IntlMessages from 'util/IntlMessages';

import { type InfoProps } from '../VehicleInfo';

const BatteryInfo: React.FC<InfoProps> = ({ connector, status }) => (
  <>
    <div className="vehicle-icon">{getVehicleIcon()}</div>
    <div className="d-flex flex-column ml-3">
      <h3 className="mb-3">
        <b>{connector?.verbose_name || connector?.connector_id || '- - -'}</b>
      </h3>
      <h6 className="color-bg-lightest text-uppercase mb-3 d-flex align-items-center">
        <div className="mr-2 connector-type-icon">{getConnectorTypeSvg(connector)}</div>
        <b>{connector?.plug_type || '- - -'}</b>
      </h6>
      <h6 className="color-bg-lightest text-uppercase d-flex align-items-center">
        <div className="mr-2">
          <ConnectorType connector={connector} />
        </div>
        <b>
          <IntlMessages id={`common.labels.${status?.toLowerCase()}`} />
        </b>
      </h6>
    </div>
  </>
);

// const WarningIcon: React.FC<{}> = ({ className, size, tooltipText, tooltipPlacement }) => {
//   return (
//     <Tooltip disableInteractive placement={tooltipPlacement} title={tooltipText}>
//       <span className={`icon-warning ${className}`}>
//         <BsFillExclamationTriangleFill size={size ?? '22px'} />
//       </span>
//     </Tooltip>
//   );
// };

export default BatteryInfo;
